module.exports = __webpack_public_path__ + "static/media/text-image.4fdd9fce.webp";